"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionOnNetwork = exports.prepareTransactionForBroadcasting = void 0;
const address_1 = require("../address");
const contractResults_1 = require("./contractResults");
const transactionLogs_1 = require("./transactionLogs");
const transactionReceipt_1 = require("./transactionReceipt");
const transactionStatus_1 = require("./transactionStatus");
function prepareTransactionForBroadcasting(transaction) {
    if ("toSendable" in transaction) {
        return transaction.toSendable();
    }
    return {
        nonce: Number(transaction.nonce),
        value: transaction.value.toString(),
        receiver: transaction.receiver,
        sender: transaction.sender,
        senderUsername: transaction.senderUsername
            ? Buffer.from(transaction.senderUsername).toString("base64")
            : undefined,
        receiverUsername: transaction.receiverUsername
            ? Buffer.from(transaction.receiverUsername).toString("base64")
            : undefined,
        gasPrice: Number(transaction.gasPrice),
        gasLimit: Number(transaction.gasLimit),
        data: transaction.data.length === 0 ? undefined : Buffer.from(transaction.data).toString("base64"),
        chainID: transaction.chainID,
        version: transaction.version,
        options: transaction.options,
        guardian: transaction.guardian || undefined,
        signature: Buffer.from(transaction.signature).toString("hex"),
        guardianSignature: transaction.guardianSignature.length === 0
            ? undefined
            : Buffer.from(transaction.guardianSignature).toString("hex"),
    };
}
exports.prepareTransactionForBroadcasting = prepareTransactionForBroadcasting;
class TransactionOnNetwork {
    constructor(init) {
        this.hash = "";
        this.type = "";
        this.nonce = 0;
        this.round = 0;
        this.epoch = 0;
        this.value = "";
        this.receiver = address_1.Address.empty();
        this.sender = address_1.Address.empty();
        this.gasLimit = 0;
        this.gasPrice = 0;
        this.function = "";
        this.data = Buffer.from([]);
        this.signature = "";
        this.status = transactionStatus_1.TransactionStatus.createUnknown();
        this.timestamp = 0;
        this.blockNonce = 0;
        this.hyperblockNonce = 0;
        this.hyperblockHash = "";
        this.receipt = new transactionReceipt_1.TransactionReceipt();
        this.contractResults = new contractResults_1.ContractResults([]);
        this.logs = new transactionLogs_1.TransactionLogs();
        Object.assign(this, init);
    }
    static fromProxyHttpResponse(txHash, response, processStatus) {
        let result = TransactionOnNetwork.fromHttpResponse(txHash, response);
        result.contractResults = contractResults_1.ContractResults.fromProxyHttpResponse(response.smartContractResults || []);
        if (processStatus) {
            result.status = processStatus;
            result.isCompleted = result.status.isSuccessful() || result.status.isFailed();
        }
        return result;
    }
    static fromApiHttpResponse(txHash, response) {
        let result = TransactionOnNetwork.fromHttpResponse(txHash, response);
        result.contractResults = contractResults_1.ContractResults.fromApiHttpResponse(response.results || []);
        result.isCompleted = !result.status.isPending();
        return result;
    }
    static fromHttpResponse(txHash, response) {
        let result = new TransactionOnNetwork();
        result.hash = txHash;
        result.type = response.type || "";
        result.nonce = response.nonce || 0;
        result.round = response.round;
        result.epoch = response.epoch || 0;
        result.value = (response.value || 0).toString();
        result.sender = new address_1.Address(response.sender);
        result.receiver = new address_1.Address(response.receiver);
        result.gasPrice = response.gasPrice || 0;
        result.gasLimit = response.gasLimit || 0;
        result.function = response.function || "";
        result.data = Buffer.from(response.data || "", "base64");
        result.status = new transactionStatus_1.TransactionStatus(response.status);
        result.timestamp = response.timestamp || 0;
        result.blockNonce = response.blockNonce || 0;
        result.hyperblockNonce = response.hyperblockNonce || 0;
        result.hyperblockHash = response.hyperblockHash || "";
        result.receipt = transactionReceipt_1.TransactionReceipt.fromHttpResponse(response.receipt || {});
        result.logs = transactionLogs_1.TransactionLogs.fromHttpResponse(response.logs || {});
        return result;
    }
    getDateTime() {
        return new Date(this.timestamp * 1000);
    }
}
exports.TransactionOnNetwork = TransactionOnNetwork;
//# sourceMappingURL=transactions.js.map